module.exports = __webpack_public_path__ + "media/jà-rern nai tam.c2264a0c.mp3";